export default "/images/person-default-image.138af1.png";